

(function ($) {
    $(function () {

        $('ul.navbar-nav li.dropdown').hover(function() {
            $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeIn(250);
        }, function() {
            $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeOut(250);
        });

    });
    
    
$('.like-button').on('click', function () {
	var $button = $(this);

	if ($button.hasClass('liked') || $button.prop('disabled')) {
		return;
	}

	var postId = $button.data('id');
	var ajaxUrl = $button.data('url');

	$button.prop('disabled', true);

	$.post(ajaxUrl, {
		action: 'lane_like_post',
		post_id: postId
	})
	.done(function (response) {
		if (response.success) {
			$button.addClass('liked');
			$button.siblings('.like-count').text(response.data.likes);
		} else {
			console.log(response);
			$button.prop('disabled', false);
		}
	})
	.fail(function (xhr) {
		console.log(xhr.responseText);
		$button.prop('disabled', false);
	});
});


$('.switch-wrapper input[type="radio"]').on('change', function () {
    var selectedCycle = $(this).val();
    var $block = $(this).closest('.membership-plans');

    $block.find('.price-tag').each(function () {
        var $priceTag = $(this);

        var price = selectedCycle === 'month'
            ? $priceTag.attr('data-month-price')
            : $priceTag.attr('data-year-price');

        var billed = selectedCycle === 'month'
            ? $priceTag.attr('data-month-billed')
            : $priceTag.attr('data-year-billed');

        $priceTag.find('.js-plan-price').text(price);

        if (billed && billed.length) {
            $priceTag.find('.js-plan-billed').text(billed).removeClass('d-none');
        } else {
            $priceTag.find('.js-plan-billed').addClass('d-none').text('');
        }
    });

    $block.find('.js-plan-feature').each(function () {
        var $feature = $(this);
        var removeOnMonth = $feature.attr('data-remove-on-month') === '1';

        if (selectedCycle === 'month' && removeOnMonth) {
            $feature.addClass('d-none');
        } else {
            $feature.removeClass('d-none');
        }
    });
});

$('[data-bs-toggle="tooltip"]').each(function () {
    var existingTooltip = bootstrap.Tooltip.getInstance(this);

    if (existingTooltip) {
        existingTooltip.dispose();
    }

    new bootstrap.Tooltip(this, {
        html: true,
        trigger: 'hover focus'
    });
});

$('.js-count-up').each(function () {
    var $counter = $(this);

    if ($counter.data('counted')) {
        return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
                return;
            }

            $counter.data('counted', true);

            var target = parseInt($counter.attr('data-count'), 10) || 0;
            var duration = 2000;
            var stepTime = Math.max(Math.floor(duration / target), 20);
            var current = 0;

            var timer = setInterval(function () {
                current += Math.ceil(target / 100);

                if (current >= target) {
                    current = target;
                    clearInterval(timer);
                }

                $counter.text(current);
            }, stepTime);

            obs.unobserve(entry.target);
        });
    }, {
        threshold: 0.4
    });

    observer.observe(this);
});


$('.featured-logos-slider').each(function () {
    new Swiper(this, {
        spaceBetween: 30,
        slidesPerView: 5,
        loop: true,
        speed: 2400,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false
        },
        breakpoints: {
            0: {
                slidesPerView: 2
            },
            640: {
                slidesPerView: 3
            },
            992: {
                slidesPerView: 4
            },
            1200: {
                slidesPerView: 5
            }
        }
    });
});

$('.testimonials-slider__carousel').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: '50px',
  arrows: true,
  dots: true,
  autoplay: true,
  autoplaySpeed: 5000,
  speed: 500,
  infinite: true,
  pauseOnHover: true,
  pauseOnDotsHover: false,
  lazyLoad: 'ondemand',

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        centerPadding: '30px'
      }
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '40px',
        arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        centerMode: false,
        centerPadding: '0',
        arrows: false
      }
    }
  ]
});

$('.content-wrap iframe').filter(function () {
	const src = $(this).attr('src') || '';

	return src.includes('youtube.com') ||
		src.includes('youtu.be') ||
		src.includes('player.vimeo.com') ||
		src.includes('wistia') ||
		src.includes('vidyard');
}).each(function () {
	const $iframe = $(this);

	if (!$iframe.parent().hasClass('embed-container')) {
		$iframe.wrap('<div class="embed-container"></div>');
	}
});

$(document).on('click', '[data-bs-target="#compareFeatureModal"]', function () {
	var description = $(this).data('description') || '';
	$('#compareModalFeatureDescription').text(description);
});

$('.top-bar[data-announcement-key]').each(function () {
    var $bar = $(this);
    var key = $bar.data('announcement-key');

    try {
        if (window.localStorage && localStorage.getItem(key) === '1') {
            $bar.remove();
            return;
        }
    } catch (e) {}

    $bar.find('.top-bar__close').on('click', function () {
        try {
            if (window.localStorage) {
                localStorage.setItem(key, '1');
            }
        } catch (e) {}
        $bar.slideUp(200, function () { $bar.remove(); });
    });
});
    
    
})(window.jQuery)

